import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import AularioView from './AularioView';
import * as ROUTES from '../../../router/Routes';

const AularioModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.aulario}
      routes={[ROUTES.controlEstudios]}
    >
      <AularioView />
    </ContainerTemplate>
  );
};

export default AularioModule;
